module.exports = __webpack_public_path__ + "img/img_lh_brand.866ca69b.png";